import { useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import {
  ColDef} from "ag-grid-community";
import "../../styles.scss";

import { getWidthFromHeader, renderValueAsJSX } from "../../../../until";
import { FlattenedField } from "../../../CustomersV2/indexV2";
import { ListField } from "../../../../api/Customer_V2/customerApi_V2";
import { ColumnKey } from "../../../Customers/Tabs/CarListCardClone";
import { ICustomerFields } from "../../../../api/salesSericeCustomer/salesSericeCustomerApi";

import FilterHeader from "./Components/FilterHeader";

const dataListFieldsByCustomerRecordActive = [
  {
    id: 99,
    title: "Thông tin hợp đồng",
    fields: [
      { id: 1, fieldCode: "model", fieldLabel: "Dòng xe", inputType: "text", isActive: 1 },
      { id: 2, fieldCode: "brand", fieldLabel: "Số máy", inputType: "text", isActive: 1 },
      { id: 3, fieldCode: "variant", fieldLabel: "Màu nội thất", inputType: "text", isActive: 1 },
      { id: 4, fieldCode: "vehicle", fieldLabel: "Loại động cơ", inputType: "text", isActive: 1 },
      { id: 5, fieldCode: "name", fieldLabel: "Ngày hợp đồng", inputType: "text", isActive: 1 },
      { id: 6, fieldCode: "plate", fieldLabel: "Số hợp đồng", inputType: "text", isActive: 1 },
      { id: 7, fieldCode: "frame", fieldLabel: "Số hóa đơn", inputType: "text", isActive: 1 }
    ]
  }
];

const dataListFieldsByCustomerRecordNotActive = [
  { id: 99, title: "Thông tin hợp đồng", fields: [] }

];

const daumData = [
  {
    id: 1,
    code: "C53343401K1234",
    name: "Xe Đức - Du lịch",
    groupPermissionId: 100,
    fields: [
      { fieldId: 1, fieldLabel: "Model", fieldCode: "model", value: "Du lịch" },
      { fieldId: 2, fieldLabel: "Brand", fieldCode: "brand", value: "53343401K1234" },
      { fieldId: 3, fieldLabel: "Variant", fieldCode: "variant", value: "Trắng" },
      { fieldId: 4, fieldLabel: "Vehicle", fieldCode: "vehicle", value: "408 20G AT" },
      { fieldId: 5, fieldLabel: "Ngày mua", fieldCode: "name", value: "21/02/2022" },
      { fieldId: 6, fieldLabel: "Plate", fieldCode: "plate", value: "075/2025/HĐMB/KIAVL-KH" },
      { fieldId: 7, fieldLabel: "Frame", fieldCode: "frame", value: "00001226" }
    ],
    permissionMenu: { groupPermissionId: 100, view: true, edit: false, delete: false }
  }
];

interface Prop {
  isSettingShow?: boolean;
  activeServiceRecordsTab: string
  setSettingShow?: (isClose: boolean) => void;
}

const ContactInformation = ({ stData = {} as any }) => {
  const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([]);
  const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([]);
  const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 15, total: 0 });

  useEffect(() => {
    gListFieldsActive();
  }, []);

  useEffect(() => {
    const codes = dataFilterActive.map((f) => f.fieldCode);
    setColumnsMapShow(codes);
  }, [dataFilterActive]);


  const gListFieldsActive = async () => {
    const flattenedFields = dataListFieldsByCustomerRecordActive.flatMap((choice) =>
      choice.fields.map((field) => ({ ...field, parentId: choice.id }))
    );
    setDataFilterActive(flattenedFields);
    gListFieldsNotActive();
  };

  const gListFieldsNotActive = async () => {
    setDataFilterNoActive(dataListFieldsByCustomerRecordNotActive);
  };

  const generateColumnsFromCodesAgGridReact = (
    codes: ColumnKey[],
    fields: ICustomerFields[],
    actionColumn?: ColDef<any, any>,
    onToggleStatus?: (id: number, next: boolean, rowData: any) => void
  ): ColDef[] => {
    const baseColumns = codes
      ?.map((code) => {
        const field = fields.find((f) => f.fieldCode === code);
        if (!field) return null;

        return {
          headerName: field.fieldLabel,
          headerComponent: FilterHeader,
          field: field.fieldCode,
          colId: field.fieldCode,
          sortable: true,
          width: getWidthFromHeader(field.fieldLabel),
          cellRenderer: (params: any) => renderValueAsJSX(params.value,field.fieldCode)
        } as ColDef;
      })
      .filter(Boolean) as ColDef[];

    return actionColumn ? [actionColumn, ...baseColumns] : baseColumns;
  };

  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReact(
      columnsMapShow,
      dataFilterActive,
      undefined,
      (id: number, next: boolean, rowData: any) => console.log(id, next, rowData)
    );
  }, [columnsMapShow, dataFilterActive]);

  const tableData = useMemo(() => {
    return daumData.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {
        acc[field.fieldCode] = field.value;
        return acc;
      }, {});

      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues
      };
    });
  }, []);


  return (
    <>

      <div className="ag-theme-alpine custom-table-ag custom-page-css" style={{ width: "100%" }}>
        <AgGridReact
          rowData={stData.xesohuu_show && stData.xesohuu_show.vehicle_owner_transactions ? [stData.xesohuu_show.vehicle_owner_transactions] : []} // Row data for rows, we pass an empty array to show the "No Rows" overlay
          columnDefs={[
            { field: 'trans_contract_date', headerName: 'Ngày lập hợp đồng' },
            { field: 'trans_payment_terms_name', headerName: 'Hình thức thanh toán' },
            { field: 'trans_doc_date', headerName: 'Ngày chứng từ' },
            { field: 'trans_paper_amount', headerName: 'Số tiền giấy' },
            { field: 'trans_total_amount', headerName: 'Tổng tiền' },
            { field: 'trans_commission_broker', headerName: 'Hoa hồng môi giới' },
            { field: 'trans_discount_amount_sr', headerName: 'Số tiền khuyến mãi' },
            { field: 'trans_promotion_item_list', headerName: 'Danh sách khuyến mãi' },
          ]}
          rowHeight={55}
          domLayout="autoHeight"
        />
      </div>
    </>
  );
};

export default ContactInformation;
